import React from 'react';
import classNames from 'classnames';

import { ContactForm } from '../../components';
import { FeatureItem } from './components';
import {
	featuresData,
	requestPageConsultingData,
} from '@store/ConsultingsData';

import * as styles from './Consulting.module.scss';

interface ConsultingProps {
	helper?: string;
	variant?: 'dark' | 'light';
	header?: string | React.ReactNode;
	disableTopMargin?: boolean;
	formLink?: string;
	requestPage?: boolean;
}

export const Consulting: React.VFC<ConsultingProps> = ({
	helper,
	header = 'Quote a project! Get advice.',
	variant = 'dark',
	disableTopMargin,
	formLink = 'https://webforms.pipedrive.com/f/1yssWoVptC0Q4iJFacTC7P7GzpmZbFa2CPby0eTcaHmd4j0mxnFvOYHH6zepqAHqr',
	requestPage = false,
}) => {
	return (
		<div
			id="free-anchor"
			className={classNames(
				styles.consultingContainer,
				variant === 'light' && styles.lightVariant,
				disableTopMargin && styles.disabledMarginTop
			)}
		>
			<div
				className={classNames(
					styles.greeting,
					'd-flex  justify-content-lg-start'
				)}
			>
				{typeof header === 'string' ? (
					<p className="font-600">{header}</p>
				) : (
					header
				)}
			</div>
			<section className={classNames(styles.consultingWrapper, helper)}>
				<div className={classNames(styles.contactForm)}>
					<ContactForm variant={variant} formLink={formLink} />
				</div>
				<div className={classNames(styles.features, 'flex-column d-flex')}>
					{requestPage
						? requestPageConsultingData.map((f) => (
								<FeatureItem key={f.text} text={f.text} icon={f.icon} />
						  ))
						: featuresData.map((f) => (
								<FeatureItem key={f.text} text={f.text} icon={f.icon} />
						  ))}
				</div>
			</section>
		</div>
	);
};
